import { FormItemName } from '@src/framework/workbench/drawer/constants';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { IItems } from '../form.interface';

/**
 * 获取shape-model需要置灰的设置项。
 * @param model 所选元素
 * @returns
 */
export const getShapeDisabledItems = (model: IShapeModel): IItems => {
    const isTextAttachment = model.isTextAttachment?.();
    const fillInfo = (model as IShapeModel).getBackgroundFill().getFillInfo();
    const isImageTileFill = !!(fillInfo?.image?.tile);
    return {
        [FormItemName.HEIGHT]: () => isTextAttachment,
        [FormItemName.WIDTH]: () => isTextAttachment,
        [FormItemName.SIZE_ADJUST]: () => isTextAttachment,
        [FormItemName.CROP_POSITIOIN_WIDTH]: () => isImageTileFill,
        [FormItemName.CROP_POSITIOIN_HEIGHT]: () => isImageTileFill,
        [FormItemName.CROP_POSITIOIN_LEFT]: () => isImageTileFill,
        [FormItemName.CROP_POSITIOIN_TOP]: () => isImageTileFill,
    };
};
